import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfig } from '../../app.config';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { UntypedFormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { PHBHPFeaturePackageConfigurationService } from 'src/app/configure/ph-bhp-feature-package-configuration.service';
import { MyTaskService } from '../myTask.service';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'app-myTaskDetail',
  templateUrl: './myTaskDetail.component.html',
  styleUrls: ['./myTaskDetail.component.css']
})
export class MyTaskDetailComponent implements OnInit {
  modalRef: BsModalRef;
  addUserFormGeneralInfo: UntypedFormGroup;
  institutionId;
  institutionChecked = {} as any;
  submitted = false;
  searchText: string;
  institutionName;
  addUser: any = {};
  emitData: any = {
    key: "",
    val: ""
  }
  countryID = 0;
  countryRadio = "";
  emailExist: boolean = false;
  uNameExist: boolean = false;
  isMultiselect: boolean = true;
  Uservalue: any = {
    user: {},
    institutions: ""
  }
  institutionRadio;
  @ViewChild('cancelmodal') cancelmodal: TemplateRef<any>;
  //@Input() userRole: string = 'Institution User';
  userData: any;
  userSubscription: Subscription;
  taskId: number;
  roleAndInstitutionsList: [any];
  institutionsList: any;
  selectins;
  userDetails;
  itemChange: boolean = false;
  user;
  countryData;
  roleDetails = [
    {
      roleName: "Super Admin",
      roleId: 1
    },
    {
      roleName: "Country Admin",
      roleId: 2
    },
    {
      roleName: "Group Admin",
      roleId: 3
    },
    {
      roleName: "Institution Admin",
      roleId: 4
    },
    {
      roleName: "Institution User",
      roleId: 5
    }
  ]
  translationKeys: typeof TranslationKeys = TranslationKeys;
  
  constructor(
    private router: Router,
    public config: AppConfig,
    private service: MyTaskService,
    private configurationService: PHBHPFeaturePackageConfigurationService,
    public layoutService: PHBHPLayoutPackageService,
    private modalService: BsModalService,
    public translate: TranslateService
  ) { }

  ngOnInit() {
    if (!this.service.userDetails) {
      this.backToManageUser();
    }
    this.userDetails = this.service.userDetails;
    this.addUserFormGeneralInfo = new UntypedFormGroup({
      name: new UntypedFormControl('', Validators.compose([Validators.required])),
      email: new UntypedFormControl('', Validators.compose([Validators.required])),
      roleId: new UntypedFormControl('', Validators.compose([Validators.required])),
      isActive: new UntypedFormControl(true),
      username: new UntypedFormControl('', Validators.compose([Validators.required]))
    });

    this.addUserFormGeneralInfo.setValue({
      name: this.service.userDetails.displayName,
      email: this.service.userDetails.email,
      roleId: "",
      isActive: this.service.userDetails.isActive,
      username: this.service.userDetails.userName
    });

    if (this.config.userData) {
      this.userData = this.config.userData;
      this.onUserChanges();
    }

    this.userSubscription = this.config.userSubject.asObservable().subscribe((changelang) => {
      this.userData = this.config.userData;
      this.onUserChanges();
    })

    this.configurationService.getCountryList().subscribe((res) => {
      this.countryData = res;
    })
    // if(this.institutionId){

    // }
  }

  onUserChanges() {
    if (this.userData && !this.itemChange) {
      if (this.userData.roleName.roleId == 2) {
        this.roleDetails.splice(0, 2);
      }
      this.itemChange = true;
      this.service.getUsersBountry(this.userData.userId).subscribe((res: any) => {
        this.roleAndInstitutionsList = res;

        if (this.taskId) {
          this.onRoleChange(this.addUserFormGeneralInfo.value.roleId, false);
        }
        // if(this.isGroup != null){
        //   if(this.isGroup == 1) {
        //     this.addUserFormGeneralInfo.patchValue({
        //       roleId: 3
        //     })
        //     this.institutionRadio = parseInt(this.institutionId);

        //   } else {
        //     this.addUserFormGeneralInfo.patchValue({
        //       roleId:4
        //     })
        //     this.institutionChecked[this.institutionId]  = true
        //   }
        //   this.addUserFormGeneralInfo.get('roleId').disable()
        //   this.service.getInstitutionById(this.institutionId).subscribe((res)=>{
        //     this.countryID = res[0].institution.countryID
        //     if( res[0].groupName != ""){
        //       this.institutionName =  res[0].groupName + " / "+res[0].institution.institutionName
        //     } else {
        //       this.institutionName =  res[0].institution.institutionName
        //     }


        //   })
        // }
      })
    }
  }

  AvoidSpace(event) {
    var k = event ? event.which : event.keyCode;
    if (k == 32) return false;
  }

  ngOnDestroy() {
    if (this.userSubscription)
      this.userSubscription.unsubscribe();
  }

  checkAll(ev) {
    this.countryID = 0;
    this.institutionsList.forEach((x, index) => {
      this.institutionChecked[x.institutionID] = ev.target.checked;
      if (index == 0 && ev.target.checked) {
        this.countryID = x.countryID;
      }
    })
  }

  submitUser(val) {
    if (this.addUserFormGeneralInfo.invalid) {
      //this.data.showError(this.data.translatetext('Add all Required Data'));
      this.submitted = true;
      return true;
    }
    var roleId = this.addUserFormGeneralInfo.get('roleId').value;
    if (roleId == 1) {
      this.countryID = 1;
    }
    if (roleId == 2 && !this.countryRadio) {
      this.layoutService.showError(this.layoutService.translateText('Select country'));
      this.submitted = true;
      return true;
    }
    if (roleId == 3 && !this.institutionRadio) {
      this.layoutService.showError(this.layoutService.translateText('Select group institution'));
      this.submitted = true;
      return true;
    }
    if (roleId == 4 || roleId == 5) {
      let selected = false;
      for (var key in this.institutionChecked) {
        if (this.institutionChecked[key])
          selected = true;
      }
      if (!selected) {
        this.layoutService.showError(this.layoutService.translateText('Select institution'));
        this.submitted = true;
        return true;
      }
    }

    this.updateUser();

  }

  institutionString() {
    if (this.isMultiselect) {
      return this.layoutService.objectString(this.institutionChecked);
    } else {
      return this.institutionRadio
    }
  }

  onRoleChange(index: number, doFalse = true) {
    var roleAndInstitutions;
    if (this.roleAndInstitutionsList) {
      if (index == 5) {
        index = 4;
      }
      roleAndInstitutions = this.roleAndInstitutionsList.find(roleAndInstitutions => roleAndInstitutions.role.roleId == index);
      if (roleAndInstitutions) {
        this.institutionsList = roleAndInstitutions.institutions;
        this.isMultiselect = roleAndInstitutions.isMultiselect;
      }
    }
    if (doFalse) {
      for (var key in this.institutionChecked) {
        this.institutionChecked[key] = false;
      }
    } if (!this.isMultiselect) {
      for (var key in this.institutionChecked) {
        this.institutionRadio = parseInt(key);
      }
    }


  }
  checkValue(institution, ev) {
    if (ev.target.checked == false) {
      this.selectins = ev.target.checked;
    }
    this.countryID = institution.countryID
  }

  checkValueradio(institution) {
    this.countryID = institution.countryID
  }
  checkValuecountry(countryID) {
    this.countryID = countryID
  }
  userNameExist() {
    var username = this.addUserFormGeneralInfo.value.username;
    if (username != "") {
      this.service.getUsernameExist(username).subscribe((res: any) => {
        this.uNameExist = res;
      })
    }
  }

  userEmailExist() {
    var email = this.addUserFormGeneralInfo.value.email;
    if (email != "") {
      // this.service.getUserEmailExist(email).subscribe((res:any)=>{
      //   this.emailExist = res;
      // })
    }
  }

  randomPassword(length) {
    var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var newpassword = "";
    for (var x = 0; x < length; x++) {
      var i = Math.floor(Math.random() * chars.length);
      newpassword += chars.charAt(i);
    }
    return newpassword;

  }


  updateUser() {
    this.Uservalue.user = this.addUserFormGeneralInfo.value;
    this.Uservalue.user.password = "GeneratePlatformPassword";
    this.Uservalue.user.updatedBy = this.userData.userId;
    this.Uservalue.user.externalAppUserId = this.service.userDetails.userId;
    this.Uservalue.user.countryId = (this.countryID) ? this.countryID : this.user.countryId;
    this.Uservalue.webUrl = this.config.siteUrl;
    this.Uservalue.languageCode = localStorage.getItem("selectedlanguage");
    this.Uservalue.institutions = this.institutionString();
    if (this.Uservalue.user.username) {
      this.Uservalue.user.username = this.Uservalue.user.username.split(' ').join('');
    }

    //value.updatedBy =this.userData.userId;
    var data = {
      personalInformation: this.Uservalue,
      platformUserPersonalInformation: this.platformUserPersonalDetails()
    }
    this.layoutService.showLoader = true;
    this.service.AddUserOrSubscribe(data).subscribe((res: any) => {
      this.layoutService.showLoader = false;
      this.backToManageUser()
    });
  }
  platformUserPersonalDetails() {
    var roleId = this.addUserFormGeneralInfo.value.roleId;
    var institutions = this.Uservalue.institutions;
    var data = {
      username: this.service.userDetails.userName,
      appUserRole: roleId,
      facilityRoleMapping: [],
      approvedBy: this.userData.userId,
      userPrincipleName: this.service.userDetails.userPrincipleName,
      isApproved: true
    }
    if (roleId == 3 || roleId == 4 || roleId == 5) {
      this.institutionsList;
      if (this.isMultiselect) {
        institutions = institutions.split(",");
      } else {
        institutions = [institutions.toString()];
      }
      var selectedList: Array<any> = this.institutionsList.filter(res => institutions.includes(res.institutionID.toString()));
      selectedList.forEach(institution => {
        var facilite = this.service.userDetails.facilities.find(res => (
          res.facilitySAPId == institution.crmNumber ||
          (res.facilityName == institution.institutionName && (institution.crmNumber == null || institution.crmNumber == ""))
        ));
        if (facilite) {
          data.facilityRoleMapping.push(facilite);
        };
      });
    }
    return data;
  }
  cancelModal() {
    if (this.addUserFormGeneralInfo.dirty) {
      this.openCancelModal(this.cancelmodal)
    }
    else {
      // this.CancelUser()
      this.backToManageUser()
    }
  }

  openCancelModal(cancelmodal: TemplateRef<any>) {
    this.modalRef = this.modalService.show(cancelmodal, Object.assign({}, { class: 'w-420' })
    )
  }


  CancelUser() {
    this.emitData = {};
    this.emitData.key = "mytask/list";
    //this.emitData.val=res.user;
    this.onChildData(this.emitData);
  }

  backToManageUser() {
    this.emitData = {
      key: "mytask/list"
    };
    this.onChildData(this.emitData);
  }

  onChildData(event: any) {
    this.router.navigate([event.key]);
  }
}
